import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getBoolean'
})
export class GetBooleanPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return (value ? 'SIM' : 'NÃO');
  }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/pipe/get-boolean.pipe.ts